"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ChatDriverProvider = exports.useEmittedDataSource = exports.ChatDriverContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * The chat driver is an omni-hook with sub-hooks that handles all chat-related frontend functionality
 */
var react_1 = __importDefault(require("react"));
var use_grouped_messages_1 = require("./use-grouped-messages");
var react_2 = require("@moopsyjs/react");
var toolkit_1 = require("@moopsyjs/toolkit");
var react_3 = require("@moopsyjs/react");
var after_interactions_1 = require("./lib/after-interactions");
var debounce_1 = require("./lib/debounce");
var pull_1 = require("./lib/pull");
var reply_to_context_1 = require("./reply-to-context");
var idle_1 = require("@hiyllo/idle");
var stardate_1 = require("@hiyllo/stardate");
var GetMessagesBP = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/get-messages"));
var MessagesPubSubSpec = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/messages-pubsub-spec"));
var MarkChatReadBP = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/mark-chat-read"));
var SetIsLookingAtChatBP = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/focus-monitoring/set-is-looking-at-chat"));
var ChatPSB = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/chat.psb"));
var ChatTypingPSB = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/focus-monitoring/chat-typing"));
var GetChatBP = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/get-chat"));
exports.ChatDriverContext = react_1["default"].createContext(null);
function useEmittedDataSource(determineInitial, event, driver) {
    var m = react_1["default"].useMemo(function () { return determineInitial(driver); }, []);
    var _a = react_1["default"].useState(m), d = _a[0], s = _a[1];
    var chatUUIDRef = react_1["default"].useRef(driver.chatUUID);
    react_1["default"].useEffect(function () {
        var cb = function (data) {
            s(data);
        };
        driver.emitter.on(event, cb);
        return function () {
            driver.emitter.off(event, cb);
        };
    }, [event, driver.emitter]);
    react_1["default"].useEffect(function () {
        if (driver.chatUUID !== chatUUIDRef.current) {
            chatUUIDRef.current = driver.chatUUID;
            s(determineInitial(driver));
        }
    }, [driver]);
    return d;
}
exports.useEmittedDataSource = useEmittedDataSource;
var ChatDriver = /** @class */ (function () {
    function ChatDriver(options, chatUUID, tenant, client, cache, self) {
        var _this = this;
        this.driverId = Math.random().toString(36).substring(7);
        this.emitter = new toolkit_1.TypedEventEmitterV3();
        this.rawMessages = {};
        this.groupedMessages = [];
        this.chatSessionCreated = new Date();
        this.lastRead = null;
        this.markChatReadLastCalled = null;
        this.latestMessage = new Date(0);
        this.oldestMessageDate = null;
        this.destroyed = false;
        this.loadOlderCooldown = null;
        this.chat = null;
        this._storeDebounce = new debounce_1.Debounce(500, 'ignore');
        this.ready = false;
        this.typingUsers = [];
        this.liveLoading = true;
        this._log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.log.apply(console, __spreadArray(["[".concat(new Date().toISOString(), "][@hiyllo/omni-chat][ChatDriver][").concat(_this.chatUUID, "]")], args, false));
        };
        this.onTransportStatusChange = function (status) {
            if (status === react_2.TransportStatus.connected) {
                _this._onActive();
            }
            else {
                _this._onIdle();
            }
        };
        this._localLoaded = false;
        this._firstLoadedLive = false;
        this._firstLoadLive = function () {
            if (_this._firstLoadedLive)
                return;
            _this._firstLoadedLive = true;
            _this._log("Loading live...");
            _this._query._perform()["finally"](function () {
                _this._log("Live data ready.");
                if (!_this.destroyed) {
                    _this._read._markChatReadIfActive();
                    _this._emitReady();
                }
            });
        };
        this._isReadyForLive = false;
        this.readyForLive = function () {
            _this._isReadyForLive = true;
            if (_this._localLoaded) {
                _this._firstLoadLive();
            }
        };
        this.setIsIdle = function (isIdle) {
            if (isIdle) {
                _this._onIdle();
            }
            else {
                _this._onActive();
            }
            _this.isIdle = isIdle;
        };
        this.recentlyIdle = false;
        this._onActive = function () {
            if (_this.destroyed)
                return;
            _this._focus._setIsLooking();
            _this._read._markChatRead();
            if (_this.ready) {
                _this._log("Became active, performing query");
                _this._query._perform()["finally"](function () {
                    _this._read._markChatReadIfActive();
                });
            }
            _this.isIdle = false;
            setTimeout(function () {
                _this.recentlyIdle = false;
            }, 3000);
        };
        this._onIdle = function () {
            if (_this.destroyed)
                return;
            _this.isIdle = true;
            _this.recentlyIdle = true;
            _this._focus._setIsNotLooking();
            _this.typing.stopTyping();
            _this.typingUsers = [];
            _this.emitter.emit('changed/typingUsers', _this.typingUsers);
        };
        this.destory = function () {
            _this._log("Destroying...");
            _this.destroyed = true;
            _this.messagesPSL.stop();
            _this.chatPSL.stop();
            _this.typingPSL.stop();
            _this.messagesPubSubSubscription.destroy();
            _this.chatPubSubSubscription.destroy();
            _this.typingPubSubSubscription.destroy();
            _this.seamlessClient.on.transportStatusChange(_this.onTransportStatusChange);
        };
        this.isIdle = false;
        this.typing = {
            _isTyping: false,
            _onMessage: function (message) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (message.isTyping) {
                        this.typingUsers = this.typingUsers.includes(message.userId) ? this.typingUsers : __spreadArray(__spreadArray([], this.typingUsers, true), [message.userId], false);
                    }
                    else {
                        this.typingUsers = (0, pull_1.pull)(this.typingUsers, message.userId);
                    }
                    this.emitter.emit('changed/typingUsers', this.typingUsers);
                    return [2 /*return*/];
                });
            }); },
            _debounce: new debounce_1.Debounce(1500, 'overwrite'),
            startTyping: function () { return __awaiter(_this, void 0, void 0, function () {
                var mutation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.typing._isTyping !== true)) return [3 /*break*/, 2];
                            this.typing._isTyping = true;
                            mutation = new react_3.MoopsyMutation(this.seamlessClient, SetIsLookingAtChatBP, { querySideEffects: [] });
                            return [4 /*yield*/, mutation.call({
                                    chatUUID: this.chatUUID,
                                    looking: true,
                                    typing: true
                                })];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.typing._debounce.run(this.typing.stopTyping);
                            return [2 /*return*/];
                    }
                });
            }); },
            stopTyping: function () { return __awaiter(_this, void 0, void 0, function () {
                var mutation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            mutation = new react_3.MoopsyMutation(this.seamlessClient, SetIsLookingAtChatBP, { querySideEffects: [] });
                            return [4 /*yield*/, mutation.call({
                                    chatUUID: this.chatUUID,
                                    looking: !this.isIdle,
                                    typing: false
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }
        };
        /**
         * Handlers for focus monitoring
         */
        this._focus = {
            _setIsLooking: function () { return __awaiter(_this, void 0, void 0, function () {
                var mutation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            mutation = new react_3.MoopsyMutation(this.seamlessClient, SetIsLookingAtChatBP, { querySideEffects: [] });
                            return [4 /*yield*/, mutation.call({
                                    chatUUID: this.chatUUID,
                                    looking: true,
                                    typing: false
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            _setIsNotLooking: function () { return __awaiter(_this, void 0, void 0, function () {
                var mutation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            mutation = new react_3.MoopsyMutation(this.seamlessClient, SetIsLookingAtChatBP, { querySideEffects: [] });
                            return [4 /*yield*/, mutation.call({
                                    chatUUID: this.chatUUID,
                                    looking: false,
                                    typing: false
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }
        };
        /**
         * Handlers for stateful data
         */
        this._data = {
            _ingest: function (messages, skipStore) {
                if (skipStore === void 0) { skipStore = false; }
                return __awaiter(_this, void 0, void 0, function () {
                    var _i, messages_1, m, e_1;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this._log("Ingesting ".concat(messages.length, " messages"));
                                if (!this.isIdle) {
                                    for (_i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                                        m = messages_1[_i];
                                        this.rawMessages[m.uuid] = m;
                                        if (m.editedDate.valueOf() > this.latestMessage.valueOf()) {
                                            this.latestMessage = m.editedDate;
                                        }
                                        if (this.oldestMessageDate == null || m.sentDate.valueOf() < this.oldestMessageDate.valueOf()) {
                                            this.oldestMessageDate = m.sentDate;
                                        }
                                    }
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 2, , 5]);
                                this._data._generateGrouped();
                                return [3 /*break*/, 5];
                            case 2:
                                e_1 = _a.sent();
                                if (!use_grouped_messages_1.ChainCompromisedError.is(e_1)) return [3 /*break*/, 4];
                                return [4 /*yield*/, this._handleChainCompromise()];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4: throw e_1;
                            case 5:
                                if (!skipStore && !this._options.noCache) {
                                    Promise.all(messages.map(function (message) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.cache.set(this._local.keys.message(message.uuid), message)];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }));
                                    this._local.store();
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            },
            _setChat: function (chat, skipStore) {
                if (skipStore === void 0) { skipStore = false; }
                if (_this.chat != null && _this.chat.lastMessageDate.valueOf() > chat.lastMessageDate.valueOf())
                    return;
                _this.chat = chat;
                _this.emitter.emit('changed/chat', chat);
                if (!skipStore) {
                    _this._local.store();
                }
            },
            _generateGrouped: function () {
                var rawMessages = Object.values(_this.rawMessages);
                _this.emitter.emit('changed/rawMessages', rawMessages);
                _this.groupedMessages = (0, use_grouped_messages_1.groupMessages)(rawMessages, _this.lastRead, _this.chatSessionCreated);
                _this.emitter.emit('changed/groupedMessages', _this.groupedMessages);
            },
            _onMessagesPS: function (message) {
                // this._data._ingest([message]);
                _this._query._performMessages();
                _this._read._markChatReadIfActive();
            },
            _onChatPS: function (message) {
                _this._data._setChat(message);
            }
        };
        /**
         * Handlers for local storage
         */
        this._local = {
            keys: {
                messageIds: function () { return "@hiyllo_omni-chat_driver_message-ids/".concat(_this.chatUUID); },
                message: function (id) { return "@hiyllo_omni-chat_driver_chat-messages_".concat(_this.chatUUID, "/").concat(id); },
                chat: function () { return "@hiyllo_omni-chat_driver_chat/".concat(_this.chatUUID); }
            },
            _loadMessages: function () { return __awaiter(_this, void 0, void 0, function () {
                var messageIds, fetchedMessages, filteredMessages;
                var _this = this;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this._options.noCache) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, this.cache.get(this._local.keys.messageIds())];
                        case 1:
                            messageIds = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : [];
                            if (messageIds.length === 0) {
                                return [2 /*return*/, this._log("No local messages available")];
                            }
                            ;
                            return [4 /*yield*/, Promise.all(messageIds.map(function (id) { return __awaiter(_this, void 0, void 0, function () {
                                    var message;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.cache.get(this._local.keys.message(id))];
                                            case 1:
                                                message = _a.sent();
                                                return [2 /*return*/, message];
                                        }
                                    });
                                }); }))];
                        case 2:
                            fetchedMessages = _b.sent();
                            filteredMessages = fetchedMessages.filter(function (message) { return message !== null; });
                            this._log("Retrieved ".concat(messageIds.length, " IDs from local, fetched ").concat(filteredMessages.length, " messages"));
                            return [4 /*yield*/, this._data._ingest(filteredMessages, true)];
                        case 3:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            _loadChat: function () { return __awaiter(_this, void 0, void 0, function () {
                var chat;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this._options.noCache) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, this.cache.get(this._local.keys.chat())];
                        case 1:
                            chat = _a.sent();
                            if (chat != null) {
                                this._log("Loaded chat from local storage");
                                this._data._setChat(chat, true);
                            }
                            else {
                                this._log("No local chat available");
                            }
                            return [2 /*return*/];
                    }
                });
            }); },
            _load: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                this._local._loadMessages(),
                                this._local._loadChat(),
                            ])];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            _store: function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (this._options.noCache) {
                        return [2 /*return*/];
                    }
                    (0, after_interactions_1.runAfterInteractions)(function () { return __awaiter(_this, void 0, void 0, function () {
                        var rawMessages, sortedMessages, messageIds;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    rawMessages = Object.values(this.rawMessages);
                                    sortedMessages = rawMessages.sort(function (a, b) { return b.editedDate.valueOf() - a.editedDate.valueOf(); }).slice(0, 50);
                                    messageIds = sortedMessages.map(function (message) { return message.uuid; });
                                    return [4 /*yield*/, this.cache.set(this._local.keys.messageIds(), messageIds)];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, this.cache.set(this._local.keys.chat(), this.chat)];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [2 /*return*/];
                });
            }); },
            store: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._storeDebounce.run(this._local._store);
                    return [2 /*return*/];
                });
            }); },
            _drop: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (this._options.noCache) {
                        return [2 /*return*/];
                    }
                    this.cache.set(this._local.keys.chat(), null);
                    this.cache.set(this._local.keys.messageIds(), null);
                    return [2 /*return*/];
                });
            }); }
        };
        this._emitReady = function () {
            _this.ready = true;
            _this.emitter.emit('changed/ready', true);
        };
        this._chainCompromiseBeingHandled = false;
        this._handleChainCompromise = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._chainCompromiseBeingHandled)
                            return [2 /*return*/];
                        this._chainCompromiseBeingHandled = true;
                        // In the event of a chain compromise, we should dump all locally stored data and trigger
                        // a full refetch from the server
                        // Drop local DBs
                        console.log("[ChatDriver] Responding to a chain compromise, dropping local");
                        return [4 /*yield*/, this._local._drop()];
                    case 1:
                        _a.sent();
                        // Reset local variables
                        console.log("[ChatDriver] Responding to a chain compromise, resetting driver");
                        this.rawMessages = {};
                        this.groupedMessages = [];
                        this.lastRead = null;
                        this.markChatReadLastCalled = null;
                        this.latestMessage = new Date(0);
                        this.oldestMessageDate = null;
                        // Refetch from server
                        console.log("[ChatDriver] Responding to a chain compromise, performing a refetch");
                        return [4 /*yield*/, this._query._perform()];
                    case 2:
                        _a.sent();
                        this._chainCompromiseBeingHandled = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.activeGetMessagesMutation = null;
        this.activeGetChatMutation = null;
        /**
         * Handlers for querying the server
         */
        this._query = {
            _getParams: function () {
                return _this._options.aroundMessageUUID != null ? { chatUUID: _this.chatUUID, aroundMessageUUID: _this._options.aroundMessageUUID } : _this.latestMessage.valueOf() === 0 ? { chatUUID: _this.chatUUID, before: new Date(Date.now() + 1000 * 60) } : { chatUUID: _this.chatUUID, after: _this.latestMessage };
            },
            _performMessages: function () { return __awaiter(_this, void 0, void 0, function () {
                var mutation, params, response, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.destroyed)
                                return [2 /*return*/];
                            if (this.activeGetMessagesMutation != null) {
                                return [2 /*return*/];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 7, , 8]);
                            mutation = new react_3.MoopsyMutation(this.seamlessClient, GetMessagesBP, { querySideEffects: [], timeout: 7500 });
                            this.activeGetMessagesMutation = mutation;
                            params = this._query._getParams();
                            return [4 /*yield*/, mutation.call(params)];
                        case 2:
                            response = _a.sent();
                            this.activeGetMessagesMutation = null;
                            if (!(response.hasMore && 'after' in params)) return [3 /*break*/, 4];
                            /*
                                We were trying to fetch messages after our latest, but there's been a lot of conversation
                                so let's just fetch messages from head instead.
                            */
                            this.latestMessage = new Date(0);
                            return [4 /*yield*/, this._query._performMessages()];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 6];
                        case 4: return [4 /*yield*/, this._data._ingest(response.messages)];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6: return [3 /*break*/, 8];
                        case 7:
                            e_2 = _a.sent();
                            if (!this.recentlyIdle) {
                                // Network and Timeout errors can occur if the app was recently or is idle
                                this.stardate.log({
                                    kind: stardate_1.StardateLogKind.error,
                                    message: "Error fetching messages",
                                    error: e_2,
                                    data: {
                                        chatUUID: this.chatUUID,
                                        transportStatus: this.seamlessClient.getTransportStatus(),
                                        // connectedFor: this.seamlessClient.transport.connectedAt == null ? -1 : Date.now() - this.seamlessClient.transport.connectedAt.valueOf(),
                                        isIdle: this.isIdle,
                                        driverId: this.driverId
                                    }
                                });
                            }
                            if (e_2 instanceof react_2.TimeoutError) {
                                // Retry after 1 second if TimeoutError
                                setTimeout(this._query._performChat, 1000);
                            }
                            throw e_2;
                        case 8: return [2 /*return*/];
                    }
                });
            }); },
            _performChat: function () { return __awaiter(_this, void 0, void 0, function () {
                var mutation, response, e_3;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this.destroyed)
                                return [2 /*return*/];
                            if (this.activeGetChatMutation != null) {
                                return [2 /*return*/];
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            mutation = new react_3.MoopsyMutation(this.seamlessClient, GetChatBP, { querySideEffects: [], timeout: 7500 });
                            this.activeGetChatMutation = mutation;
                            return [4 /*yield*/, mutation.call(this._query._getParams())];
                        case 2:
                            response = _b.sent();
                            this.activeGetChatMutation = null;
                            this._data._setChat(response.chat);
                            if (this.lastRead == null) {
                                this.lastRead = (_a = response.chat.lastRead) !== null && _a !== void 0 ? _a : null;
                                this.emitter.emit('changed/lastRead', this.lastRead);
                                this._data._generateGrouped();
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            e_3 = _b.sent();
                            if (!this.recentlyIdle) {
                                // Network and Timeout errors can occur if the app was recently or is idle
                                this.stardate.log({
                                    kind: stardate_1.StardateLogKind.error,
                                    message: "Error fetching chat",
                                    error: e_3,
                                    data: {
                                        chatUUID: this.chatUUID,
                                        transportStatus: this.seamlessClient.getTransportStatus(),
                                        // connectedFor: this.seamlessClient.transport.connectedAt == null ? -1 : Date.now() - this.seamlessClient.transport.connectedAt.valueOf(),
                                        isIdle: this.isIdle,
                                        driverId: this.driverId
                                    }
                                });
                            }
                            if (e_3 instanceof react_2.TimeoutError) {
                                // Retry after 1 second if TimeoutError
                                setTimeout(this._query._performChat, 1000);
                            }
                            throw e_3;
                        case 4: return [2 /*return*/];
                    }
                });
            }); },
            _perform: function () { return __awaiter(_this, void 0, void 0, function () {
                var stardate;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.destroyed)
                                return [2 /*return*/];
                            stardate = new stardate_1.Stardate(stardate_1.StardateSourceEnum.frontendPackage, "omni-chat", "chat-driver", this.tenant, this.self.userId);
                            if (this.seamlessClient.getTransportStatus() !== react_2.TransportStatus.connected) {
                                return [2 /*return*/, stardate.log({
                                        kind: stardate_1.StardateLogKind.trace,
                                        message: "Not performing query as transport is not connected"
                                    })];
                            }
                            this.liveLoading = true;
                            this.emitter.emit("changed/liveLoading", true);
                            return [4 /*yield*/, Promise.all([
                                    this._query._performMessages(),
                                    this._query._performChat(),
                                ])];
                        case 1:
                            _a.sent();
                            this.liveLoading = false;
                            this.emitter.emit("changed/liveLoading", false);
                            return [2 /*return*/];
                    }
                });
            }); }
        };
        /**
         * Handlers for maintaing read state
         */
        this._read = {
            _debounce: new debounce_1.Debounce(1000, 'overwrite'),
            _markChatRead: function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this._read._debounce.run(function () { return __awaiter(_this, void 0, void 0, function () {
                        var mutation;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    mutation = new react_3.MoopsyMutation(this.seamlessClient, MarkChatReadBP, { querySideEffects: [] });
                                    this.markChatReadLastCalled = new Date();
                                    return [4 /*yield*/, mutation.call({ chatUUID: this.chatUUID })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [2 /*return*/];
                });
            }); },
            _markChatReadIfActive: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!this.isIdle) return [3 /*break*/, 2];
                            return [4 /*yield*/, this._read._markChatRead()];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            this._log('Incoming, but not marking as read as inactive');
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); }
        };
        this.loadOlder = function () { return __awaiter(_this, void 0, void 0, function () {
            var mutation, res, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.oldestMessageDate == null || (this.loadOlderCooldown != null && this.loadOlderCooldown.valueOf() > Date.now())) {
                            return [2 /*return*/, { fetched: -1 }];
                        }
                        this.loadOlderCooldown = new Date(Infinity); // Lock further loadOlder requests
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        mutation = new react_3.MoopsyMutation(this.seamlessClient, GetMessagesBP, { querySideEffects: [] });
                        return [4 /*yield*/, mutation.call({
                                chatUUID: this.chatUUID,
                                before: this.oldestMessageDate
                            })];
                    case 2:
                        res = _a.sent();
                        this._data._ingest(res.messages, true);
                        this.loadOlderCooldown = new Date(Date.now() + 500);
                        return [2 /*return*/, { fetched: res.messages.length }];
                    case 3:
                        e_4 = _a.sent();
                        this.loadOlderCooldown = new Date(Date.now() + 500);
                        this.stardate.log({
                            kind: stardate_1.StardateLogKind.error,
                            message: "Error fetching older messages",
                            error: e_4,
                            data: {
                                chatUUID: this.chatUUID
                            }
                        });
                        return [2 /*return*/, { fetched: -1 }];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this._log("Constructing for \"".concat(chatUUID, "\"..."));
        this._options = options;
        this.chatUUID = chatUUID;
        this.tenant = tenant;
        this.seamlessClient = client;
        this.cache = cache;
        this.self = self;
        this.stardate = new stardate_1.Stardate(stardate_1.StardateSourceEnum.frontendPackage, "omni-chat", "chat-driver", this.tenant, this.self.userId);
        this.messagesPubSubSubscription = client.createPubSubSubscription({
            topic: "[".concat(tenant, "]chat.messages/").concat(chatUUID),
            topicId: MessagesPubSubSpec.TopicID,
            params: null
        });
        this.messagesPSL = this.messagesPubSubSubscription.listen(this._data._onMessagesPS);
        this.chatPubSubSubscription = client.createPubSubSubscription({
            topic: "[".concat(tenant, "]chat.chat/").concat(chatUUID, "/for:").concat(self.userId),
            topicId: ChatPSB.TopicID,
            params: null
        });
        this.chatPSL = this.chatPubSubSubscription.listen(this._data._onChatPS);
        this.typingPubSubSubscription = client.createPubSubSubscription({
            topic: "[".concat(tenant, "]chat-typing/").concat(chatUUID),
            topicId: ChatTypingPSB.TopicID,
            params: null
        });
        this.typingPSL = this.typingPubSubSubscription.listen(this.typing._onMessage);
        this._log("Constructed. Loading data...");
        this._local._load()["catch"](function (err) {
            _this.stardate.log({
                kind: stardate_1.StardateLogKind.error,
                message: "Error while loading initial chat data from local",
                error: err,
                data: {
                    chatUUID: _this.chatUUID
                }
            });
        })["finally"](function () {
            _this._localLoaded = true;
            _this._log("Loaded local. Waiting...");
            (0, after_interactions_1.runAfterInteractions)(function () {
                if (_this._isReadyForLive) {
                    _this._firstLoadLive();
                }
            });
        });
        this.seamlessClient.on.transportStatusChange(this.onTransportStatusChange);
    }
    return ChatDriver;
}());
var ChatDriverProviderInner = /** @class */ (function (_super) {
    __extends(ChatDriverProviderInner, _super);
    function ChatDriverProviderInner(props) {
        var _this = _super.call(this, props) || this;
        _this.constructed = false;
        _this.constructChatDriver = function () {
            var _a;
            return new ChatDriver({
                preload: (_a = _this.props.preload) !== null && _a !== void 0 ? _a : false,
                aroundMessageUUID: _this.props.aroundMessageUUID,
                noCache: _this.props.aroundMessageUUID != null
            }, _this.props.chatUUID, _this.props.tenant, _this.props.seamlessClient, _this.props.cache, _this.props.self);
        };
        if (_this.constructed)
            return _this;
        _this.constructed = true;
        console.log("Constructing a ChatDriverProvider for \"".concat(props.chatUUID, "\""), {
            aroundMessageUUID: _this.props.aroundMessageUUID
        });
        _this.state = {
            chatDriver: _this.constructChatDriver()
        };
        return _this;
    }
    ChatDriverProviderInner.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.chatUUID !== prevProps.chatUUID) {
            console.log("[@hiyllo/omni-chat][ChatDriver] Chat UUID changed, re-constructing...", { old: prevProps.chatUUID, "new": this.props.chatUUID });
            var oldChatDriver = this.state.chatDriver;
            this.setState({
                chatDriver: this.constructChatDriver()
            });
            oldChatDriver.destory();
        }
        if (this.props.isIdle !== prevProps.isIdle) {
            this.state.chatDriver.setIsIdle(this.props.isIdle);
        }
    };
    ChatDriverProviderInner.prototype.componentWillUnmount = function () {
        this.state.chatDriver.destory();
    };
    ChatDriverProviderInner.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(exports.ChatDriverContext.Provider, __assign({ value: this.state.chatDriver }, { children: (0, jsx_runtime_1.jsx)(reply_to_context_1.ReplyToProvider, { children: this.props.children }) })));
    };
    return ChatDriverProviderInner;
}(react_1["default"].PureComponent));
var ChatDriverProvider = react_1["default"].memo(function ChatDriverProvider(props) {
    var _a;
    var isIdle = (0, idle_1.useIsIdle)();
    return ((0, jsx_runtime_1.jsx)(ChatDriverProviderInner, __assign({}, props, { isIdle: isIdle }), props.chatUUID + ((_a = props.aroundMessageUUID) !== null && _a !== void 0 ? _a : "")));
});
exports.ChatDriverProvider = ChatDriverProvider;
